import { styled } from '@mui/material/styles';
import { Grid, Container as MuiContainer, Typography } from '@mui/material';

export const Container = styled(MuiContainer)({
  padding: 0,
  margin: 0,
  position: 'relative',
});

export const StyledHighchartsMap = styled('div')({
  position: 'relative',
});

export const TooltipTable = styled('table')({
  borderCollapse: 'collapse',
  borderRadius: '9px',
  borderSpacing: 0,
  '& th': {
    textAlign: 'left',
    padding: '8px',
    backgroundColor: '#f4f4f4',
  },
  '& td': {
    padding: '8px',
    borderBottom: '1px solid #ddd',
  },
});

export const CountryLabel = styled(Typography)({
  fontWeight: 600,
  fontSize: '17.5px',
  lineHeight: '21.33px',
  marginLeft: '3px',
  opacity: '0.7',
});

export const LegendContainer = styled(Grid)({
  justifyContent: 'center',
  alignContent: 'start',
  alignItems: 'start',
  marginTop: '20px',
  position: 'absolute',
  display: 'flex',
  flexDirection: 'column',
  right: '22%',
  bottom: '14%',
});

export const NoteForMap = styled(Typography)({
  fontSize: 9,
  lineHeight: '10.97px',
  fontStyle: 'italic',
  marginBottom: '7px',
});

export const GradientBox = styled('div')<{ color: string }>`
  width: 252.53px;
  height: 15px;
  background: ${(props: any) => props.color};
  border-radius: 4px;
`;

export const MapLabelGrid = styled(Typography)({
  display: 'flex',
  justifyContent: 'center',
  alignContent: 'center',
  alignItems: 'center',
  flexDirection: 'row',
});

export const MapLabelBox = styled('div')<{ color: string }>`
  width: 10px;
  height: 10px;
  background: ${(props: any) => props.color};
`;

export const MapLabelText = styled(Typography)({
  marginLeft: '5px',
  fontWeight: 400,
  fontSize: '11.23px',
  lineHeight: '13.69px',
});
